import type { SavedCard } from '../../../../types/order.types';
import { CardType } from '../../../../types/order.types';

export const NAME_PATTERN = /^[a-zA-Z.,' -]*$/;

export function formatCardNumber(raw: string): string {
  const cleaned = raw.replace(/\D/g, '');
  return cleaned.replace(/(.{4})/g, '$1 ').trim();
}

export function resolveCardType(type: string): string | null {
  const upper = type?.toUpperCase();
  if (
    upper === CardType.VISA ||
    upper === CardType.MASTERCARD ||
    upper === CardType.AMEX ||
    upper === CardType.DISCOVER
  ) {
    return type.toLowerCase();
  }
  return null;
}

export function cvcLengthForType(cardType: string): number {
  return cardType?.toUpperCase() === CardType.AMEX ? 4 : 3;
}

export type EditDisplayField = 'cardNumber' | 'name' | 'expiryDate' | 'cvc' | 'zipCode';

export function isUpdateButtonDisabled(
  isUpdate: boolean,
  cardDetails: SavedCard | undefined,
  cardName: string,
  cardExpiryDate: string,
  defaultCard: boolean,
  cardCVC: string,
  zipCode: string,
  cardNumber: string,
): boolean {
  if (isUpdate && cardDetails) {
    const origName = cardDetails.lastName
      ? `${cardDetails.firstName} ${cardDetails.lastName}`
      : cardDetails.firstName;
    const origExpiry = `${cardDetails.expirationMonth}/${cardDetails.expirationYear?.slice(-2)}`;
    return (
      cardName === origName &&
      cardExpiryDate === origExpiry &&
      defaultCard === cardDetails.default
    );
  }
  return !cardCVC && !cardExpiryDate && !cardName && !zipCode && !cardNumber;
}

export function getEditDisplayValue(
  isUpdate: boolean,
  cardDetails: SavedCard | undefined,
  field: EditDisplayField,
): string {
  if (!isUpdate || !cardDetails) return '';
  switch (field) {
    case 'cardNumber': return `************${cardDetails.cardNumber}`;
    case 'name': return cardDetails.lastName
      ? `${cardDetails.firstName} ${cardDetails.lastName}`
      : cardDetails.firstName;
    case 'expiryDate': return `${cardDetails.expirationMonth}/${cardDetails.expirationYear?.slice(-2)}`;
    // DV-2789: CVV is not retained, so there's nothing to pre-fill on edit (the CVC field is
    // hidden in update mode in CardFormModal). Kept in the switch for exhaustiveness.
    case 'cvc': return '';
    case 'zipCode': return cardDetails.zipCode ?? '';
  }
}

export function displayCardType(
  isUpdate: boolean,
  detectedCardType: string,
  cardDetailsType?: string,
): CardType | null {
  const upper = (isUpdate ? cardDetailsType : detectedCardType)?.toUpperCase();
  if (upper === CardType.VISA) return CardType.VISA;
  if (upper === CardType.MASTERCARD) return CardType.MASTERCARD;
  if (upper === CardType.AMEX) return CardType.AMEX;
  if (upper === CardType.DISCOVER) return CardType.DISCOVER;
  return null;
}
